import axios from "axios"

const http = {

	install ({ Actions, Query }) {

		const fetch = ({state, dispatch}, data) => {
			const id = (typeof data === "number" || typeof data === "string") ? data : null
			const params = typeof data === "object" ? data : {}
			const model = Query.getModel(state.$name)
			const endpoint = `${model.endpoint}${(id) ? '/'+id : ''}`
			return axios.get(endpoint, { params }).then((res) => {
				const data = res.data.data || res.data
				const meta = res.data.meta || {}
				dispatch('insertOrUpdate', { data })
				return { data, meta }
			})
		}

		Actions.fetchOne = fetch

		Actions.fetchAll = fetch

	}

}

export default http



// WEBPACK FOOTER //
// ./src/store/plugins/http.js